import axios from "axios";
import { headers } from "../exports/exports";

export const fetchMunicipality = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_locationUrl}/municipality`
    );
    return response.data;
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchPolicies = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/ega-admission-policies?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};
